import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hqschs56r: FaireProductEntity = {
  token: "p_3hqschs56r",
  type: "product",
  name: "Enamel Virgin Mary Religious Coin Gold-Filled Pendant Charm",
  brandToken: "b_7ef699gcdg",
  brandName: "Beads Creation",
  imageUrl:
    "https://cdn.faire.com/fastly/451d4e75ff51ec607a87ab237053a55d10e1fa3c62af87a7c0b6e139c16186e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fcdda004a6afdd95a48bbd0861736c46ad5aaaf6f6f3dbb5be02cafc5e122713.jpeg",
    "https://cdn.faire.com/fastly/3f79146396b7ef02b61e635e764a3b7d467493ee044905c1985f791292d5d0cc.jpeg",
    "https://cdn.faire.com/fastly/6347b96ebb645eab5485bd6fd52d4bb36170368036df868d88b99ec5ee931a95.jpeg",
    "https://cdn.faire.com/fastly/01168a4792e049b614dd3b45473643ee655eaebe1c5d1b73e34ff649cab78548.jpeg",
    "https://cdn.faire.com/fastly/6c3955c1c986b1156853066b119220011445eb485ff3d381740317cc24df4d4b.jpeg",
    "https://cdn.faire.com/fastly/1a313d0e43e1f040fc07c6e38302c8d8921b344be27910a268bde26a77009017.jpeg",
    "https://cdn.faire.com/fastly/551d8014be0d1d2d3cadbec92baab37ace004f0ff8ee2277c96ec76412698394.jpeg",
    "https://cdn.faire.com/fastly/40f34c4e940abfcb5e6707f898d547fa99e03f10c6fcd9647ad3f4db3245eecf.jpeg",
    "https://cdn.faire.com/fastly/b81e5383a416f22edd8af6f937c3af02ef1a1898201a9039d0067288885b5edb.jpeg",
    "https://cdn.faire.com/fastly/a8cf60072be7f5383c34d25565a28a0bc63f08885fd67b3d67e8d0b8c1baf784.jpeg",
    "https://cdn.faire.com/fastly/ace112aa7aeba5e586f3cc5833f9ab7281ff8f664980d08153aebbfdbf5a5112.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Creating your handcrafted jewelry pieces starts here! This is the best place to shop for fashionable and stylish jewelry findings with premium quality and competitive price!\nTake a look at more detail information about this item:\n\nDescription: \nMaterial: Brass Based with 18K Gold Filled, Enamel\nSize: 18X10MM\nQTY: 1PC\n\n★Ship from CA, USA★\n\nAll sizes are approximate \nLead Free & Cadmium Free & Nickel Free\n\nIf you any questions regarding our products, bulk discount, and issue please send us a message\nThank you for your visit!\n\nCARE INSTRUCTIONS\n\nTo care for your delicate jewelry and maintain its quality and longevity, please follow these guidelines:\n\n- Avoid contact with chemical solutions, perfumes, sweat, and saltwater/chlorine.\n- Use a soft, damp cloth to wipe off your jewelry regularly.\n- Keep your jewelry dry to prevent tarnishing.\n- Store different types of jewelry separately in a sealed bag to prevent oxidization.",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:42.505Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
